/**
 * Hard sync: fit-tool phone (ego_phone) MUST match SC Options before Add to Cart.
 * - Prefills brand + model from cookie
 * - Snaps back if customer changes away from saved phone
 * - Blocks Add to Cart until STEP 2 matches saved phone
 */
(function () {
  if (window.__egoScPrefillInit) return;
  window.__egoScPrefillInit = true;

  var COOKIE = 'ego_phone';
  var MAX_MS = 20000;
  var STEP_MS = 250;
  var MATCH_OK = 90;
  var state = {
    synced: false,
    lastPhone: null
  };

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function readPhone() {
    try {
      var o = JSON.parse(getCookie(COOKIE) || '');
      if (o && o.brand && o.model) return o;
    } catch (e) {}
    return null;
  }

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[™®]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fire(el, type) {
    try {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    } catch (e) {
      var ev = document.createEvent('HTMLEvents');
      ev.initEvent(type, true, false);
      el.dispatchEvent(ev);
    }
  }

  function optionsRoot() {
    return (
      document.querySelector('.bold_options_loaded') ||
      document.querySelector('.bold_options')
    );
  }

  function fallbackActive() {
    return !!document.querySelector('form[data-ego-fallback-active="true"]');
  }

  function visible(el) {
    if (!el) return false;
    var st = window.getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function ensureBanner() {
    var form = document.querySelector('form.product-single__form');
    if (!form) return null;
    var el = document.getElementById('ego-sc-lock-banner');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ego-sc-lock-banner';
    el.setAttribute('role', 'status');
    el.style.cssText =
      'display:none;margin:0.75rem 0;padding:0.75rem 0.9rem;border:1px solid #a5d6a7;' +
      'background:#e8f5e9;color:#1b5e20;font-size:14px;line-height:1.4;border-radius:4px;';
    var mount = form.querySelector('.bold_options') || form.firstChild;
    if (mount && mount.parentNode) mount.parentNode.insertBefore(el, mount.nextSibling);
    else form.insertBefore(el, form.firstChild);
    return el;
  }

  function showBanner(phone, ok) {
    var el = ensureBanner();
    if (!el || !phone) return;
    el.style.display = 'block';
    if (ok) {
      el.style.borderColor = '#a5d6a7';
      el.style.background = '#e8f5e9';
      el.style.color = '#1b5e20';
      el.innerHTML =
        '<strong>Ordering for: ' +
        phone.brand +
        ' ' +
        phone.model +
        '</strong><br>' +
        '<span style="font-size:12.5px;">This is locked from your phone fit selection. ' +
        'To change it, use the fit badge / “Change” above, then wait for STEP 2 to update.</span>';
    } else {
      el.style.borderColor = '#ffcc80';
      el.style.background = '#fff8e1';
      el.style.color = '#e65100';
      el.innerHTML =
        '<strong>Confirm your phone in STEP 2:</strong> ' +
        phone.brand +
        ' ' +
        phone.model +
        '<br><span style="font-size:12.5px;">Add to Cart stays blocked until STEP 2 matches this phone.</span>';
    }
  }

  function hideBanner() {
    var el = document.getElementById('ego-sc-lock-banner');
    if (el) el.style.display = 'none';
  }

  function optionMatchScore(optionText, model) {
    var a = norm(optionText);
    var b = norm(model);
    if (!a || !b || a.indexOf('select') === 0 || a === 'your apple iphone model' || a.indexOf('your ') === 0 && a.indexOf('model') !== -1 && a.length < 28) {
      return 0;
    }
    if (a === b) return 100;
    var a2 = a.replace(/\(.*?\)/g, '').trim();
    var b2 = b.replace(/\(.*?\)/g, '').trim();
    if (a2 === b2) return 96;
    if (a.indexOf(b) !== -1 || b.indexOf(a) !== -1) return 88;
    var ta = a.split(/[^a-z0-9+]+/).filter(Boolean);
    var tb = b.split(/[^a-z0-9+]+/).filter(Boolean);
    if (!ta.length || !tb.length) return 0;
    var hit = 0;
    tb.forEach(function (tok) {
      if (ta.indexOf(tok) !== -1) hit += 1;
    });
    var ratio = hit / Math.max(tb.length, 1);
    return ratio >= 0.9 ? 85 : 0;
  }

  function clickBrand(root, brand) {
    var target = norm(brand);
    var inputs = root.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    var i;
    for (i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var lab = inp.closest('label') || (inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null);
      var txt = norm((lab && lab.textContent) || inp.value || '');
      if (txt === target || (txt.indexOf(target) !== -1 && txt.length < 36)) {
        if (!inp.checked) {
          inp.click();
          inp.checked = true;
          fire(inp, 'input');
          fire(inp, 'change');
        }
        return true;
      }
    }
    var nodes = root.querySelectorAll('label, button, .bold_option_value, [data-value]');
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!visible(el)) continue;
      var t = norm(el.getAttribute('data-value') || el.textContent);
      if (t === target || (t.indexOf(target) === 0 && t.length < target.length + 10)) {
        el.click();
        return true;
      }
    }
    return false;
  }

  function findBestModelOption(root, model) {
    var selects = root.querySelectorAll('select');
    var best = null;
    var bestScore = 0;
    var bestSelect = null;
    var s;
    for (s = 0; s < selects.length; s++) {
      var sel = selects[s];
      if (!visible(sel)) continue;
      var j;
      for (j = 0; j < sel.options.length; j++) {
        var score = optionMatchScore(sel.options[j].text, model);
        if (score > bestScore) {
          bestScore = score;
          best = sel.options[j];
          bestSelect = sel;
        }
      }
    }
    if (!best || bestScore < MATCH_OK) return null;
    return { select: bestSelect, option: best, score: bestScore };
  }

  function selectedModelScore(root, model) {
    var selects = root.querySelectorAll('select');
    var best = 0;
    var i;
    for (i = 0; i < selects.length; i++) {
      var sel = selects[i];
      if (!visible(sel) || sel.selectedIndex < 0) continue;
      var opt = sel.options[sel.selectedIndex];
      if (!opt) continue;
      var score = optionMatchScore(opt.text, model);
      if (score > best) best = score;
    }
    return best;
  }

  function applyModel(root, model) {
    var hit = findBestModelOption(root, model);
    if (!hit) return false;
    if (hit.select.value !== hit.option.value) {
      hit.select.value = hit.option.value;
      fire(hit.select, 'input');
      fire(hit.select, 'change');
    }
    // Keep forcing this select if user changes it
    hit.select.setAttribute('data-ego-locked-model', model);
    return selectedModelScore(root, model) >= MATCH_OK;
  }

  function syncNow() {
    var phone = readPhone();
    state.lastPhone = phone;

    if (!phone) {
      state.synced = false;
      hideBanner();
      return true;
    }

    if (fallbackActive()) {
      // Theme fallback path already uses cookie-driven selectors
      state.synced = true;
      showBanner(phone, true);
      return true;
    }

    var root = optionsRoot();
    if (!root) {
      state.synced = false;
      showBanner(phone, false);
      return false;
    }

    var hasUi = root.querySelector('select, input[type="radio"], input[type="checkbox"]');
    if (!hasUi) {
      state.synced = false;
      showBanner(phone, false);
      return false;
    }

    clickBrand(root, phone.brand);
    var ok = applyModel(root, phone.model);
    if (!ok) {
      // brand may need a beat before model dropdown exists
      state.synced = false;
      showBanner(phone, false);
      return false;
    }
    state.synced = selectedModelScore(root, phone.model) >= MATCH_OK;
    showBanner(phone, state.synced);
    return state.synced;
  }

  function enforceSelectChange(e) {
    var phone = readPhone();
    if (!phone || fallbackActive()) return;
    var sel = e.target;
    if (!sel || sel.tagName !== 'SELECT') return;
    if (!sel.closest('.bold_options, .bold_options_loaded')) return;
    var score = optionMatchScore(sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].text, phone.model);
    if (score >= MATCH_OK) {
      state.synced = true;
      showBanner(phone, true);
      return;
    }
    // Snap back to saved phone
    setTimeout(function () {
      syncNow();
      alert(
        'Your phone is locked to:\n' +
          phone.brand +
          ' ' +
          phone.model +
          '\n\nTo order a different phone, change it in the phone fit selector first.'
      );
    }, 0);
  }

  function guardAddToCart(e) {
    var phone = readPhone();
    if (!phone) return; // no fit selection — SC Options required fields handle it
    if (fallbackActive()) return;

    var root = optionsRoot();
    if (!root) {
      e.preventDefault();
      e.stopPropagation();
      alert('Phone options are still loading. Please wait a second and try again.');
      return;
    }

    // Force sync right before cart
    syncNow();
    var score = selectedModelScore(root, phone.model);
    if (score < MATCH_OK) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      showBanner(phone, false);
      alert(
        'Please wait until STEP 2 shows your phone:\n\n' +
          phone.brand +
          ' ' +
          phone.model +
          '\n\nAdd to Cart is blocked until this matches, so the wrong model cannot be ordered.'
      );
      // keep trying
      setTimeout(syncNow, 200);
      setTimeout(syncNow, 800);
    }
  }

  function bindGuards() {
    var form = document.querySelector('form.product-single__form');
    if (form && !form.__egoScGuard) {
      form.__egoScGuard = true;
      form.addEventListener('submit', guardAddToCart, true);
      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[type="submit"], [name="add"], .addtocart, .add-to-cart');
        if (!btn || !form.contains(btn)) return;
        // validate on click too (some themes ajax without submit)
        var phone = readPhone();
        if (!phone || fallbackActive()) return;
        syncNow();
        var root = optionsRoot();
        if (!root || selectedModelScore(root, phone.model) < MATCH_OK) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          showBanner(phone, false);
          alert(
            'STEP 2 must show:\n' +
              phone.brand +
              ' ' +
              phone.model +
              '\n\nWrong phone model orders are blocked.'
          );
        }
      }, true);
    }
    document.addEventListener('change', enforceSelectChange, true);
  }

  function start() {
    bindGuards();

    var phone = readPhone();
    if (phone) showBanner(phone, false);

    var started = Date.now();
    var timer = setInterval(function () {
      try {
        var ok = syncNow();
        if ((ok && readPhone()) || Date.now() - started > MAX_MS) {
          // keep a light watchdog while on page if phone saved
          if (!readPhone()) clearInterval(timer);
        }
      } catch (err) {}
    }, STEP_MS);

    // slower ongoing enforcement
    setInterval(function () {
      try {
        if (readPhone() && !fallbackActive()) syncNow();
      } catch (e) {}
    }, 2000);

    try {
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && BOLD.common.eventEmitter.on) {
        BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function () {
          setTimeout(syncNow, 150);
          setTimeout(syncNow, 600);
          setTimeout(syncNow, 1200);
        });
      }
    } catch (e) {}

    document.addEventListener('ego:phone-updated', function () {
      state.synced = false;
      setTimeout(syncNow, 100);
      setTimeout(syncNow, 500);
      setTimeout(syncNow, 1200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
